import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { IconChevronLeft } from '@travel-frontend/icons';
import { sortBy } from 'lodash';
import { useTranslation } from 'next-i18next';
import { RatingGroup } from '../../../../../../components/HotelDetailsOverlay/components/AmadeusRatingSection/components/RatingDetails/components/RatingGroup.js';
import { Recommendation } from '../../../../../../components/HotelDetailsOverlay/components/AmadeusRatingSection/components/RatingDetails/components/Recommendation.js';
import { ReviewAttributes } from '../../../../../../components/HotelDetailsOverlay/components/AmadeusRatingSection/components/ReviewAttributes.js';
import { ScoreBar } from '../../../../../../components/HotelDetailsOverlay/components/AmadeusRatingSection/components/ScoreBar.js';
import { UserAge } from '../../../../../../components/HotelDetailsOverlay/components/AmadeusRatingSection/components/UserAge.js';
import { UserName } from '../../../../../../components/HotelDetailsOverlay/components/AmadeusRatingSection/components/UserName.js';
import { getFullName } from '../../../../../../components/HotelDetailsOverlay/components/AmadeusRatingSection/utils/getFullName.js';
import { AMADEUSREVIEW_CATEGORY_PRIORITY } from '../../../../../../components/HotelDetailsOverlay/models.js';
import { ImageGalleryPreview } from '../../../../../../components/ImageGalleryPreview/index.js';
import { ActionLink, HeadlineLarge, HeadlineMedium, HelpTooltip, Flex, ParagraphMedium, Notice } from '../../../../../../primitives/index.js';
import { qaId, HOTEL_DETAILS_QA_ID } from '../../../../../../utils/qaId.js';
export const RatingDetails = ({
  review,
  onClickBackButton,
  onClickImage
}) => {
  const {
    t
  } = useTranslation('hotelDetailsOverlay');
  if (!review) {
    return null;
  }
  const ratingGroups = sortBy(Object.entries(review.ratingGroups).filter(([category, group]) =>
  /**
   * @FIXME
   * What if i want to rate it 0?
   * Should be `null` if it's not rated.
   */
  group.rating !== 0 && AMADEUSREVIEW_CATEGORY_PRIORITY.includes(category)), ([category]) => AMADEUSREVIEW_CATEGORY_PRIORITY.indexOf(category));
  return _jsxs(Flex, {
    spacing: "pages/small",
    children: [_jsx("div", {
      children: _jsxs(ActionLink, {
        size: "medium",
        bold: true,
        onClick: onClickBackButton,
        children: [_jsx(IconChevronLeft, {}), t('amadeusRatingSection.reviewItem.back')]
      })
    }), _jsx(HeadlineLarge, {
      "data-testid": qaId(HOTEL_DETAILS_QA_ID, 'amadeusratingsection-headline'),
      children: _jsxs(Flex, {
        direction: "row",
        alignItems: "center",
        spacing: "4px",
        children: [t('amadeusRatingSection.summary.titleInDetails'), _jsx(HelpTooltip, {
          placement: "bottom",
          content: t('amadeusRatingSection.summary.tooltip')
        })]
      })
    }), _jsxs(Flex, {
      spacing: "pages/small",
      children: [_jsxs(Flex, {
        direction: "row",
        justifyContent: "space-between",
        alignItems: "flex-start",
        children: [_jsxs(Flex, {
          spacing: "4px",
          children: [_jsx(UserName, {
            firstName: review.firstName,
            lastName: review.lastName
          }), _jsx(UserAge, {
            age: review.age,
            language: review.language,
            nationality: review.nationality
          })]
        }), !review.headline && _jsx(ScoreBar, {
          rating: review.rating,
          contained: true
        })]
      }), _jsxs(Flex, {
        spacing: "headlines/medium",
        children: [review.headline && _jsxs(Flex, {
          direction: "row",
          justifyContent: "space-between",
          alignItems: "flex-start",
          children: [_jsx(HeadlineMedium, {
            children: review.headline
          }), _jsx(ScoreBar, {
            rating: review.rating,
            contained: true
          })]
        }), _jsx(ReviewAttributes, {
          review: review
        })]
      }), review.recommendation && _jsx("div", {
        children: _jsx(Recommendation, {
          children: t('amadeusRatingSection.reviewItem.recommendation', {
            firstName: getFullName({
              firstName: review.firstName,
              lastName: review.lastName
            })
          })
        })
      }), review.conclusion && _jsxs(_Fragment, {
        children: [_jsx(ParagraphMedium, {
          children: review.conclusion
        }), Boolean(review.language && review.originalLang && review.language !== review.originalLang) && _jsx(Notice, {
          variant: "info",
          children: t('amadeusRatingSection.translationHint')
        })]
      }), Array.isArray(review.photos) && review.photos.length > 0 && _jsx(ImageGalleryPreview, {
        images: review.photos.map(photo => ({
          src: photo,
          alt: ''
        })),
        onClickImage: ({
          index
        }) => {
          onClickImage(index);
        }
      }), ratingGroups.length > 0 && _jsxs(Flex, {
        children: [_jsx(HeadlineMedium, {
          children: t('amadeusRatingSection.reviewItem.ratingCategory')
        }), _jsx(Flex, {
          divider: true,
          spacing: "dividers/medium",
          children: ratingGroups.map(([category, group]) => _jsx(RatingGroup, {
            ratingGroupId: category,
            ratingGroup: group
          }, category))
        })]
      })]
    }), _jsx("div", {
      children: _jsxs(ActionLink, {
        size: "medium",
        bold: true,
        onClick: onClickBackButton,
        children: [_jsx(IconChevronLeft, {}), t('amadeusRatingSection.reviewItem.back')]
      })
    })]
  });
};